import { render, staticRenderFns } from "./EnginePerformance.vue?vue&type=template&id=26801d6b&scoped=true&"
import script from "./EnginePerformance.vue?vue&type=script&lang=js&"
export * from "./EnginePerformance.vue?vue&type=script&lang=js&"
import style0 from "./EnginePerformance.vue?vue&type=style&index=0&id=26801d6b&scoped=true&lang=css&"
import style1 from "./EnginePerformance.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26801d6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!G:/www-purejs/EdsOnLineMobile/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VTab,VTabItem,VTabs})
